import _ from 'lodash';
import * as actions from 'app/actions/account-settings';

export default function(state = {}, action) {
  switch (action.type) {
    case actions.SET_PENDING_INVITES: {
      return Object.assign({}, state, {
        pendingInvites: _.get(action, 'result'),
      });
    }
    case actions.SET_USER_PURCHASE_HISTORY: {
      return Object.assign({}, state, {
        purchaseHistory: _.get(action, 'result.orders'),
      });
    }
    case actions.SET_SETTINGS_PAGE: {
      return Object.assign({}, state, {
        settingsPage: _.get(action, 'result'),
      });
    }
    case actions.SET_USER_PAYMENT_METHODS: {
      return Object.assign({}, state, {
        creditCards: _.get(action, 'result.credit_cards'),
        availableCredit: _.get(action, 'result.store_credit'),
      });
    }
    case actions.SET_USER_INVITE_ACCEPT_PAGE: {
      return Object.assign({}, state, {
        SET_NO_GLOWFORGE_PAGE: _.get(action, 'result.fields'),
      });
    }
    case actions.UPDATE_CREDIT_CARD: {
      return Object.assign({}, state, { creditCards: _.get(action, 'result.payment') });
    }
    case actions.UPDATE_CREDIT_CARD_ERROR: {
      // NOTE: THIS IS A BUG WITH CREDIT CARD SETTING
      // IF THERE IS AN ERROR IT RE-SETS YOU PAYMENT METHODS TO NOTHING
      return Object.assign({}, state, { creditCards: null });
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/account-settings.js